import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export default function Categories() {
  const { t } = useLanguage();
  // Duplicate for seamless loop
  const items = [...t.categories.items, ...t.categories.items];

  return (
    <section
      data-testid="categories-section"
      className="relative overflow-hidden border-y border-black/5 bg-[#FAFAFA] py-20 md:py-28 dark:border-white/10 dark:bg-[#080808]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 mb-10 md:mb-14">
        <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase text-[#F37021] mb-3">
          — {t.categories.eyebrow}
        </span>
        <h2 className="max-w-2xl font-display text-3xl font-bold leading-tight text-[#111] sm:text-4xl md:text-5xl dark:text-white">
          {t.categories.title}
        </h2>
      </div>

      {/* Marquee */}
      <div className="relative" data-testid="categories-marquee">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#FAFAFA] to-transparent md:w-40 dark:from-[#080808]" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#FAFAFA] to-transparent md:w-40 dark:from-[#080808]" />

        <div className="flex gap-10 md:gap-16 whitespace-nowrap animate-marquee">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-10 md:gap-16 shrink-0">
              <span className="cursor-default font-display text-5xl font-bold text-[#111] transition-colors hover:text-[#F37021] sm:text-6xl md:text-7xl dark:text-white">
                {item}
              </span>
              <span className="font-display text-4xl md:text-5xl text-[#F37021] shrink-0">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
